module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/pickup-1-9103df60e36b3374663bfa664335cbbc.png";